var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulsingStripesDivelitPlum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 30,
    width: 15,
    height: 40,
    fill: "#AEA5CC"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "18;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "64;40;40",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.2s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 30,
    width: 15,
    height: 40,
    fill: "#8E81B8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "20.999999999999996;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "58.00000000000001;40;40",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.1s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 30,
    width: 15,
    height: 40,
    fill: "#6D5DA4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "20.999999999999996;30;30",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "58.00000000000001;40;40",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulsingStripesDivelitPlum);
export default __webpack_public_path__ + "static/media/pulsing-stripes-divelit-plum.36eb3cc6d28c7f7164ce041d9bf823bf.svg";
export { ForwardRef as ReactComponent };